import { getChannelContextCode, getChannelContextMsg } from 'helpers/Utility';
import { setError, setHomePath } from 'store/actions/auth';
import { setIsSameContactOther } from 'store/actions/loanApply';

/**
 * to handle error from put application
 * @param {*} dispatch
 * @param {*} err
 * @returns
 */
export const handleApplicationPutError = (dispatch, err) => {
  dispatch(setHomePath('/continue-apply'));

  const code = getChannelContextCode(err, 'channel-context');
  const msg = getChannelContextMsg(err, 'channel-context');

  const errorMap = {
    211053: 'error_minimum_balance',
    11017: 'same-phonenum-relationship',
    11018: 'same-phonenum-other',
    1021: 'error_postalcode_district',
    1022: 'error_postalcode_ktp',
    1023: 'error_postalcode_company',
  };

  if (code in errorMap) {
    dispatch(setError(errorMap[code]));
    if (code === '11018') dispatch(setIsSameContactOther(true));
    return;
  }

  if (
    code === '1005' ||
    code === '1006' ||
    msg?.includes('No data found on ececuser.commoncodes')
  ) {
    dispatch(setError('error_cocd'));
    return;
  }

  if (err.toString().includes('Network Error')) {
    dispatch(setError('connection'));
  } else {
    dispatch(setError('system'));
  }
};
